import axios from "axios";
import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface InventoryNfePreviewLine {
  c_prod: string;
  c_ean: string | null;
  x_prod: string;
  quantity: number;
  expires_at: string | null;
  cost_price_cents: number;
  product_id: number | null;
  product_name: string | null;
  unmatched: boolean;
}

export interface InventoryNfeConfirmLine {
  product_id: number;
  quantity: number;
  expires_at?: string | null;
  cost_price_cents?: number | null;
  c_prod?: string | null;
  c_ean?: string | null;
  x_prod?: string | null;
  supplier_cnpj?: string | null;
}

export const previewInventoryNfeImport = async (
  unitId: number,
  xmlFile: File
): Promise<ApiResponse<InventoryNfePreviewLine[]>> => {
  const formData = new FormData();
  formData.append("unit_id", String(unitId));
  formData.append("xml", xmlFile);

  return axios.post("/inventory/nfe-import/preview", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }) as Promise<ApiResponse<InventoryNfePreviewLine[]>>;
};

export const confirmInventoryNfeImport = (
  unitId: number,
  lines: InventoryNfeConfirmLine[]
): Promise<ApiResponse<{ batch_ids: number[] }>> =>
  api.create<ApiResponse<{ batch_ids: number[] }>>(
    "/inventory/nfe-import/confirm",
    { unit_id: unitId, lines }
  );
